import React, { useEffect, useRef } from 'react';

interface TikTokEmbedProps {
  videoId: string;
}

const TikTokEmbed: React.FC<TikTokEmbedProps> = ({ videoId }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const existingScript = document.querySelector('script[src*="tiktok.com/embed.js"]');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://www.tiktok.com/embed.js';
      script.async = true;

      document.body.appendChild(script);
    } else if ((window as any).tiktokEmbed) {
      (window as any).tiktokEmbed.lib.render(containerRef.current);
    }
  }, [videoId]);

  if (!videoId) return null;

  const embedUrl = `https://www.tiktok.com/embed/v2/${videoId}`;

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#000',
        overflow: 'hidden',
      }}
    >
      <iframe
        src={embedUrl}
        title="TikTok Video"
        style={{
          width: 'auto',
          height: '100%',
          minWidth: '325px',
          maxWidth: '605px',
          aspectRatio: '9 / 16',
          border: 'none',
        }}
        allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
        allowFullScreen
        scrolling="no"
      />
    </div>
  );
};

export default TikTokEmbed;
